export const prepareGradeSeoUrlSlug = (prefix: string, item: string, parent: string) => {
  return [...parent.split(' '), ...prefix.split(' '), ...item.split(' ')].filter(Boolean).join('-');
};
